import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppService } from '@app/app.service';
import { loggerFor } from '@app/utils/logger';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PortalInitialisedGuard {
  private appInitialised$: Observable<boolean>;

  private initialized: boolean = false;
  private logger = loggerFor('PortalInitialisedGuard');

  constructor(
    private appService: AppService,
    private router: Router
  ) {
    this.appInitialised$ = this.appService.initialized$;
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let returnValue: Observable<boolean | UrlTree> | boolean | UrlTree = this.initialized;

    if (this.initialized === false) {
      this.logger.info('Called');

      returnValue = this.appInitialised$.pipe(
        map((initialized) => {
          this.initialized = initialized;

          return this.initialized || this.router.createUrlTree(['/login']);
        })
      );
    }

    return returnValue;
  }
}
